<i [nimbusIcon]="icons.EXCLAMATION_TRIANGLE" class="exclamation-triangle"></i>

{{ model.name | translate: model.nameParams }}
@if (isDisabled) {
  <nimbus-mat-icon-overlay [isMediumSize]="true" [icon]="icons.INFO_CIRCLE_LIGHT">
    {{ disabledMessage }}
  </nimbus-mat-icon-overlay>
}

@if (tooltipText) {
  <nimbus-tooltip [text]="tooltipText" />
}
